<template lang="pug">
.users-guest-card-table
  card-table(:total-items='data.length' breakpoint-size='lg')
    template(v-for='(item, index) in data' v-slot:[`card-${index}`]='{}')
      .mb-1 {{ $t('usersGuestCardTable.name') }}: {{ item.name }}
      .mb-1 {{ $t('usersGuestCardTable.email') }}: {{ item.email }}
      .mb-1 {{ $t('usersGuestCardTable.userSince') }}: {{ item.joined_at | dateTime }}
      .mb-1.profile
        icon.profile-icon(
          :key='`card-owner-icon-${item.id}`'
          name='user-shield'
          v-if='item.is_owner === true'
        )
        icon.profile-icon(
          :key='`card-user-icon-${item.id}`'
          name='user'
          v-else
        )
        |
        span(:class='{ owner__organization: item.is_owner === true }')
          | {{ getUserRoleNames(item) }}
      .mb-0
        button(
          :key='`card-owner-profile-${item.id}`'
          @click.stop='openSetProfileModal(item)'
          v-if='item.is_owner === true && item.id !== $root.user.id'
          v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
        )
          icon(name='user-shield')
        button(
          :key='`card-own-profile-${item.id}`'
          disabled
          v-if='item.is_owner === true && item.id === $root.user.id'
          v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
        )
          icon(name='user-shield')
        button(
          :key='`card-user-profile-${item.id}`'
          @click.stop='openSetProfileModal(item)'
          v-if='!item.is_owner'
          v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
        )
          icon(name='user-shield')
        button.btn--delete-user(
          :key='`card-delete-user-${item.id}`'
          @click.stop='openDeleteUserModal(item.id)'
          data-bs-target='#delete-user-modal'
          v-if='!item.is_owner'
          v-tooltip:bottom='$t("usersGuestCardTable.deleteUser")'
        )
          icon.icon--canceled(name='trash-can')
    template(v-slot:table-head)
      th(style='width: 30%') {{ $t('usersGuestCardTable.name') }}
      th(style='width: 25%') {{ $t('usersGuestCardTable.email') }}
      th(style='width: 15%') {{ $t('usersGuestCardTable.userSince') }}
      th(style='width: 20%')
        span {{ $t('usersGuestCardTable.profile') }}
        icon.ms-2(
          name='circle-question'
          v-tooltip:top='$t("usersGuestCardTable.profileTooltip")'
        )
      th(style='width: 10%')
    template(v-for='(item, index) in data' v-slot:[`table-row-${index}`]='{}')
      td {{ item.name }}
      td {{ item.email }}
      td {{ item.joined_at | dateTime }}
      td.profile
        icon.profile-icon(
          :key='`table-owner-icon-${item.id}`'
          name='user-shield'
          v-if='item.is_owner === true'
        )
        icon.profile-icon(
          :key='`table-user-icon-${item.id}`'
          name='user'
          v-else
        )
        |
        span(:class='{ owner__organization: item.is_owner === true }')
          | {{ getUserRoleNames(item) }}
      td
        .text-end
          // - start set user permissions profile
          button(
            :key='`table-owner-profile-${item.id}`'
            @click.stop='openSetProfileModal(item)'
            v-if='item.is_owner === true && item.id !== $root.user.id'
            v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
          )
            icon(name='user-shield')
          button(
            :key='`table-own-profile-${item.id}`'
            disabled
            v-if='item.is_owner === true && item.id === $root.user.id'
            v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
          )
            icon(name='user-shield')
          button(
            :key='`table-user-profile-${item.id}`'
            @click.stop='openSetProfileModal(item)'
            v-if='!item.is_owner'
            v-tooltip:left='$t("usersGuestCardTable.changePermissionsProfile")'
          )
            icon(name='user-shield')
          // - end set user permissions profile  
          button(
            :key='`table-delete-user-${item.id}`'
            @click.stop='openDeleteUserModal(item.id)'
            data-bs-target='#delete-user-modal'
            v-if='!item.is_owner'
            v-tooltip:bottom='$t("usersGuestCardTable.deleteUser")'
          )
            icon.icon--canceled(name='trash-can')
  delete-user-modal(
    :user-id='selectedUserId'
    @refresh='$emit("item-deleted", selectedUserId)'
    ref='deleteUserModal'
  )
  set-permission-profile-user-modal(
    :is-owner='selectedUserIsOwner'
    :profiles-list='profilesList'
    :user-id='selectedOwnerUserId'
    :user-name='selectedUserName'
    :user-roles='selectedUserRoles'
    @navigate-profiles='fetchRolesProfiles'
    @refresh='$emit("item-updated")'
    @selected-profile='selectedProfile = $event'
    ref='setPermissionProfileUserModal'
  )
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import DeleteUserModal from '@/modules/account/components/organisms/modals/DeleteUserModal.vue';
import SetPermissionProfileUserModal from '@/modules/business/components/organisms/modals/SetPermissionProfileUserModal.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import PermissionsService from '@/services/PermissionsService';
import Logger from '@/services/Logger';

export default {
  name: 'UsersGuestCardTable',
  components: {
    Icon,
    DeleteUserModal,
    SetPermissionProfileUserModal,
    CardTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedUserId: '',
      selectedOwnerUserId: '',
      selectedUserIsOwner: false,
      selectedProfile: null,
      selectedUserName: '',
      selectedUserRoles: [],
      profilesList: {
        data: [],
        links: {},
        meta: {},
      },
    };
  },
  async created() {
    await this.fetchRolesProfiles();
  },
  computed: {
    roleNamesByUuid() {
      const roles = this.profilesList?.data || [];
      return roles.reduce((names, role) => {
        names[role.id] = role.name;
        return names;
      }, {});
    },
  },
  methods: {
    async fetchRolesProfiles(page = 1) {
      this.$loading(true);
      const params = new URLSearchParams({ page });
      await PermissionsService.listAvailableRolesProfile(params.toString())
        .then((response) => {
          this.profilesList = response.data;
        })
        .catch((error) => {
          Logger.consoleError('Error fetch roles profiles', error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    openDeleteUserModal(id) {
      this.selectUserToSendModal(id);
      this.$refs.deleteUserModal.$refs.modal.open();
    },
    selectUserToSendModal(user) {
      this.selectedUserId = user;
    },
    async openSetProfileModal(user) {
      this.selectedOwnerUserId = user.id;
      this.selectedUserIsOwner = user.is_owner === true;
      this.selectedUserRoles = [...(user.roles || [])];
      this.selectedUserName = user.name;
      await this.$nextTick();
      this.$refs.setPermissionProfileUserModal.$refs.modal.open();
    },
    getUserRoleNames(user) {
      const rolesTranslationsKeys = PermissionsService.rolesTranslationsKeys;

      const names = (user.roles || []).map((id) => {
        const name = this.roleNamesByUuid[id];
        if (!name) return '';
        const translation = rolesTranslationsKeys[name];
        return translation ? this.$t(translation) : name;
      });

      if (user.is_owner === true) {
        names.unshift(this.$t('usersGuestCardTable.owner'));
      }

      return names.join(', ');
    },
  },
};
</script>

<style lang="stylus">
.users-guest-card-table
  .btn-reinvite-user
    i
      color: #013D52;
  .btn--delete-user
    position: absolute
    top: 0.5rem
    right: 0.5rem
  .owner__organization
    font-weight: 600
    color: #013D52
  .profile
    span
      position: absolute
      top: 0.7rem
  .profile-icon
    margin-right: 0.25rem
    vertical-align: middle
    top: 0.5rem

.users-guest-card-table
  .table-card__item--card
    .profile
      display: flex
      align-items: center
      gap: 0.25rem

      > span
        position: static
        top: auto
        min-width: 0
        overflow-wrap: anywhere

      > .profile-icon
        margin-right: 0
        flex-shrink: 0

    > .mb-0
      display: flex
      justify-content: flex-start
      align-items: center
      text-align: start

      > button:not(.btn--delete-user)
        margin-inline: 0
        padding-inline: 0
        display: inline-flex
        align-items: center
        justify-content: flex-start

.users-guest-card-table
  .table-card
    table-layout: fixed
  .table-card__item--row
    td
      overflow-wrap: anywhere

    td.profile
      > .profile-icon
        float: left
        margin-right: 0
        margin-top: 0.2em

      > span
        position: static
        top: auto
        display: block
        margin-left: 1.5rem
        white-space: normal
        overflow-wrap: anywhere
</style>
